import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { environment } from '../../environments/environment';
import { AppCookieServiceService } from '../services/app-cookie-service.service';

@Injectable({
  providedIn: 'root'
})
export class ConstantsService {

  public HOME_URL = environment.serverUrl;
  public IMPORT_FILE_EXTNS = ["xlsx", "xls"];
  public FILE_SIZE = 10 * 1024 * 1024;
  public IMG_EXTNS = ['jpg', 'JPG', 'jpeg', 'JPEG', 'png', 'PNG'];
  public FILE_EXTNS = [' ', 'JPG', 'jpeg', 'JPEG', 'png', 'PNG', 'pdf', 'PDF'];
  public VB_ADMIN_USER = 'VB_ADMIN_USER';
  public DATE_FORMAT = 'EEEE d MMMM';
  readonly DEFAULT_PROFILE_PHOTO: string = 'assets/images/profile/profile.svg';

  constructor(private appCookieService: AppCookieServiceService) { }

  public MESSAGES: any = {
    'ERROR': "Could not perform the request",
    'UNAUTHORIZED': "You're not authorized to access this page",
    'FORBIDDEN': "You don't have permission to access this page"
  }

  public RESPONSE_CODES: any = {
    'SUCCESS': '200'
  }

  // Server Url
  public SERVER_URLS: any = {
    'IMAGE_URL': 'file/url',
    'FILE_VIEW': 'file/view/',
    'LOGIN': 'user/login',
    'REGISTER_USER': 'user/register',
    'VERIFY_OTP':'user/verify-otp',
    'FORGOT_PASSWORD': 'user/forgot-password',
    'RESET_PASSWORD': 'user/reset-password',
    'RESEND_USER_OTP': 'user/resend-otp',
    'TODAY_VISITS': 'visit/todays-visits',
     'ALL_TODAY_VISITS': 'visit/all-todays-visits',
    'TOMORROW_VISITS': 'visit/tomorrow-visits',
    'LATER_VISITS': 'visit/later-visits',
    'VISITS_STATUS_COUNT': 'visit/visits-status-count',
    'STATUS_VISITS': 'visit/status-visit',
    'CREATE_VISIT': 'visit/create',
    'ACTIVE_LOCATIONS':'location/active',
    'ACTIVE_ASSETS': 'asset-type/active',
    'VISIT_VERIFY_OTP':'visit/verify-otp',
    'CANCEL_VISITS':'visit/cancel-visit/',
    'COMPLETE_VISITS':'visit/complete-visit/',
    'APPROVE_VISITS':'visit/approve-visits',
    'RESCHEDULE_VISITS':'visit/reschedule-visit',
    'VISIT_DETAILS':'visit/',
    'PENDING_TAB_COUNTS':'visit/pending-tab-counts',
    'GENERATE_INVITATION_LINK':'visit-invitation/generate-link',
    'SEND_INVITATION':'visit-invitation/send-invitation',
    'VERIFY_INVITATION':'visit-invitation/verify-invitation',
    'SUBMIT_REQUEST_DETAILS':'visit/submit-visitor',
    'EDIT_VISIT':'visit/update-visit/',
    'ACTIVE_VEHICLE_TYPES':'vehicle-type/active',
    'ACTIVE_PURPOSE_TYPES':'purpose-type/active',
    'ACTIVE_ID_PROOF_TYPES':'id-proof-type/active',
    'HOST_USERS':'user/host-list',
    'CHANGE_USER_STATUS':'user/change-status',
    'RESEND_VISIT_OTP':'user/resend-visit-otp/',
    'VISITOR_LIST':'visitors/visitors-list',
    'VISITORS_REPORT':'report/visitors',
    'VISITS_REPORT':'report/visits',
    'DOWNLOAD_VISITORS_REPORT':'report/visitors/excel',
    'DOWNLOAD_VISITS_REPORT':'report/visits/excel',
    'BLACK_LISTED_VISITOR':'visitors/blacklisted-visitor',
    'SETTING':'setting',
    'FAVOURITE':'favorite-visitor/list',
    'ADD_FAVOURITE':'favorite-visitor/toggle/',
    'DELETE_FAVOURITE':'favorite-visitor/',
    'FREQUENT_VISITOR': 'visitors/frequent-visitors',
    'ALL_VISITORS_COUNT': 'visitors/counts',
    'VISIT_DETAILS_CARD': 'visit/card/',
    'USER_DETAILS': 'user/',
    'UPDATE_USER_PHOTO': 'user/photo/',
    'REMOVE_PROFILE_PHOTO': 'user/remove-photo/',
    'CHANGE_PASSWORD': 'user/change-password',
    'VISIT_LOCATION_QR_STATUS': 'location/qr-status/',
    'CHECK_USER': 'user/check-employee',
    'SUBMIT_REQUEST_DETAILS_BY_SCAN':'visit/submit-visitor-by-scan',
    'SUBMIT_REQUEST_DETAILS_BY_RECEPTION':'visit/submit-visitor-by-reception',
    'DECLARATION':'declarations',
    'VISITS_HISTORY':'visit/visitor-history/',
    'TRAINING_VIDEO':'training-videos',
    'CHECK_VISIT_SCHEDULED':'visit/check-visit-Scheduled/',
    'LATEST_VISITID':'visit/latest-visitid/',
    'CREATE_VISIT_WITH_PREVIOUS_DETAILS':'visit/create-visit-by-previous-details',
    'REQUEST_BLACKLIST':'request/blacklist',
    'REQUEST_WHITELIST':'request/whitelist',
    'REQUEST_LIST':'request/list',
    'WHITELIST_VISITOR':'request/whitelist-visitor',
    'BLACKLIST_VISITOR':'request/blacklist-visitor',
    'DENY_BLACKLIST': 'request/deny-blacklist',
    'DENY_WHITELIST': 'request/deny-whitelist',
    'REQUEST_BY_ID':'request',
    'SEARCH_HOSTS':'report/visits/hosts/search',
    'SEARCH_USERS':'user/search',
    'SEND_MOBILE_OTP':'mobile-otp/send-otp',
    'VERIFY_MOBILE_OTP':'mobile-otp/verify-otp',
    'RESEND_MOBILE_OTP':'mobile-otp/resend-otp',
    'COMPLETE_ONBOARDING': 'visit/complete-onboarding/',
    'ONBOARDING_STATUS': 'visit/onboarding-status/',
    'GET_PENDING_MANAGER_APPROVAL_COUNT': 'visit/pending-approvals-count',
    'TEAM_VISITS': 'visit/team-visits',
    'CANCEL_VISIT_BY_MANAGER': 'visit/cancel-visit-by-manager/',
    'APPROVE_VISITS_BY_MANAGER': 'visit/approve-visit-by-manager',
    'IS_USER_MANAGER': 'user/is-manager',
    'REQUEST_FOR_CANCEL': 'visit/request-cancellation/',
    'DENY_CANCELLATION': 'visit/deny-cancellation/',
    'DENY_RESCHEDULE': 'visit/deny-reschedule/',
    'REQUEST_FOR_RESCHEDULE': 'visit/request-reschedule',

    // Master Data
    'COMPANY_PROFILE':'company-profile',
    'VISIT_LOCATIONS':'location',
    'CARDS': 'cards',
    'CARDS_AVAILABILITY': 'cards/availability/',
    'CARDS_SWAP': 'cards/swap/',
    'VEHICLE_TYPES':'vehicle-type',
    'VISIT_PURPOSE':'purpose-type',
    'ID_PROOF_TYPES':'id-proof-type',
    'BLACKLIST_WHITELIST_REASONS':'blacklist-whitelist-reasons',
    'VISITOR_ASSETS': 'asset-type',

    // Roles Permissions And Users
    'ROLE': 'role',
    'ROLE_MODULE': 'role/modules',
    'ROLE_ACTIVE': 'role/active',
    'ROLE_OBJECT': 'role/role-object',
    'SET_ACTIVE_ROLE': 'role/set-active-role',
    'USER':'user',

    // Notifications
    'NOTIFICATION_COUNT':'notification/unread-count',
    'NOTIFICATION_LIST':'notification/unread-list',
    'ALL_NOTIFICATION_LIST':'notification/list',
    'MARK_ALL_AS_READ':'notification/mark-all-as-read',
    'NOTIFICATION':'notification',

    'VISIT_DETAILS_QR':'visit/visit-details/',
    'CHECK_IN_VISITS':'visit/checked-in-visit/',
    'CHECK_OUT_VISITS':'visit/checked-out-visit/',
    'ACCESS_DENIED_VISITS':'visit/access-denied/',
  }

  public VALIDATION_PATTERNS: any = {
    'EMAIL': '^(?=.{1,64}@)[A-Za-z0-9_-]+(\\.[A-Za-z0-9_-]+)*@[^-][A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$',
    'MOBILE': '(^$|[0-9]{10})',
    'ZIP_CODE': '(^$|[0-9]{6})'
  }

  public getSession(): any | null {
    return this.appCookieService.getSessionData(this.VB_ADMIN_USER);
  }

  public setSession(data: any): void {
    this.appCookieService.setSessionData(this.VB_ADMIN_USER, data, 1);
  }

  public setRoleSession(roleName:any): void {
    this.appCookieService.setRoleData(roleName);
  }

  public getRoleSession(): string {
    return this.appCookieService.getRoleData();
  }

  public clearSession(): void {
    this.appCookieService.clearSessionData(this.VB_ADMIN_USER);
    this.appCookieService.clearSessionData('originalRole');
  }

  public getAuthHeader() {
    const user = this.getSession();
    if (user) {
      return 'Bearer ' + (user && user.sessionToken ? user.sessionToken : '');
    } else {
      return '';
    }
  }

  public convertToBase64(file: File): Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => result.next(reader.result!.toString());
    return result;
  }

  public hasPermission(...args: string[]) {
    let hasPermission = false;
    const user = this.getSession();
    if (user) {
      if (args.indexOf(user.role.name) > -1) {
        hasPermission = true;
      }
    }
    return hasPermission;
  }

  public hasModulePermission(module: string, action: string) {
    let hasPermission = false;
    const user = this.getSession();
    // console.log("Pemission", user);
    if (user) {
      let roleAction = user.role.actionList.find((element:any) => element.module == module);
      if (roleAction && ((action == 'ADD' && roleAction.addAction) || (action == 'UPDATE' && roleAction.updateAction)
        || (action == 'LIST' && roleAction.listAction) || (action == 'DELETE' && roleAction.deleteAction))) {
        hasPermission = true;
      }

    }
    return hasPermission;
  }


  public getImageUrl(imageName: string) {
    return this.HOME_URL + this.SERVER_URLS['IMAGE_URL'] + imageName + '/';
  }


  public getBase64(file:any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  public checkFileExtension(fileExt: string) {
    if (this.FILE_EXTNS.indexOf(fileExt) > -1)
      return true;
    else
      return false;
  }

  public checkImageExtension(imgName:any) {
    if (this.IMG_EXTNS.indexOf(imgName) > -1)
      return true;
    else
      return false;
  }

  public checkIfAlphabetsWithOneSpace(event: any): void {
    const pattern = /^[A-Za-z\s]*$/; // Only alphabets and space allowed
    let inputChar = String.fromCharCode(event.charCode);
    const inputValue = event.target.value;
  
    // Prevent space at the start of the input
    if (inputChar === ' ' && inputValue.length === 0) {
      event.preventDefault();
      return;
    }
  
    // Prevent multiple spaces
    if (inputChar === ' ' && inputValue[inputValue.length - 1] === ' ') {
      event.preventDefault();
      return;
    }
  
    // Allow only alphabets and one space between them
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  public checkIfAllCharacters(event: any): void {
    const inputChar = String.fromCharCode(event.charCode);
    const inputValue = event.target.value;
    
    // Prevent space at the start of the input
    if (inputChar === ' ' && inputValue.length === 0) {
      event.preventDefault();
      return;
    }
  
    // Prevent multiple spaces
    if (inputChar === ' ' && inputValue[inputValue.length - 1] === ' ') {
      event.preventDefault();
      return;
    }
  }
  public checkFileSize(photo:any) {
    if (Math.round(photo.size / 1024) > this.FILE_SIZE) {
      return false;
    } else {
      return true;
    }
  }
  
  formatTo12Hour(time24: string): string {
  const [hours, minutes] = time24.split(':').map(Number);
  const period = hours >= 12 ? 'PM' : 'AM';
  const hours12 = hours % 12 || 12;
  return `${hours12}:${minutes.toString().padStart(2, '0')} ${period}`;
}
}